import { render, staticRenderFns } from "./GetLeavingCertSanjivani.vue?vue&type=template&id=529a193e&scoped=true&"
import script from "./GetLeavingCertSanjivani.vue?vue&type=script&lang=js&"
export * from "./GetLeavingCertSanjivani.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529a193e",
  null
  
)

export default component.exports